import { useMsal } from "@azure/msal-react";
import React, { memo, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import PuiButton from "../../../../components/elements/PuiButton";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import { AppState } from "../../../../root/RootReducer";
import { isUnavailable } from "../../../../utils/LogicUtils";
function LoginUnavailable() {
    const { instance } = useMsal();
    const history = useHistory();

    const { userInfo } = useSelector((state: AppState) => ({ userInfo: state.user.userInfo }));
    
    // ログイン画面に戻る処理
    const Logout = () => {
        localStorage.clear();
        instance.logout();
    };
    
    // 利用の有効無効判定
    useEffect(() => {
        if (!isUnavailable(userInfo?.roles)) {
            history.push("/homepage");
        }
    }, [userInfo, history]);

    return (
        <>
            <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                <div
                    style={{
                        color: "white",
                        textAlign: "center",
                        width: "100%",
                    }}
                >
                    システムが利用できません。 
                    {!IsDevice("desktop") && <br/>}
                    管理者にお問い合わせください。
                </div>
                <div
                    style={{ width: "250px", height: "50px", textAlign: "center", marginTop: "30px" }}
                >
                    <PuiButton onClick={Logout}>ログイン画面に戻る</PuiButton>
                </div>
            </div>
        </>
    );
}
export default memo(LoginUnavailable);
